import React from 'react';
interface ContentLayoutProps {
  children: React.ReactNode;
}
export function ContentLayout({
  children
}: ContentLayoutProps) {
  return <div className="px-8 md:px-16 py-12 md:py-16" data-id="element-119">
      <div className="max-w-[65ch]" data-id="element-120">
        {children}

        {/* Copyright message for mobile view */}
        <div className="mt-12 md:hidden" data-id="element-121">
          <p className="text-fluid-sm text-[#7A8290]" data-id="element-122">© All rights reserved</p>
        </div>
      </div>
    </div>;
}